"use client"

import { useLocation } from "react-router"

import { NavItemButton, type NavItem } from "@/components/nav-item"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

export function NavGroup({
  label,
  items,
}: {
  label: string
  items: NavItem[]
}) {
  const { pathname } = useLocation()

  if (!items.length) return null

  return (
    <SidebarGroup className="group-data-[collapsible=icon]:hidden">
      <SidebarGroupLabel>{label}</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => (
          <SidebarMenuItem key={item.title}>
            <NavItemButton item={item} isActive={pathname === item.url} />
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
